import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth-guard';

// Supabase auto-detects the session in the URL via detectSessionInUrl.
// Once the AuthProvider has resolved a session + team member, redirect to
// /my-day (the personalised home).
export function AuthCallbackRoute() {
  const navigate = useNavigate();
  const { session, teamMember, loading, error } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (session && teamMember) {
      navigate('/my-day', { replace: true });
    } else if (!loading) {
      const params = new URLSearchParams();
      if (error) params.set('reason', error);
      navigate(`/login${params.toString() ? '?' + params.toString() : ''}`, { replace: true });
    }
  }, [loading, session, teamMember, error, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
      Finishing sign-in…
    </div>
  );
}
